<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="searchRecords()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_SEARCH') }}</span>
                </b-button>
                <!-- <b-button
                  v-if="$ability.can(constants.action.permissionLetterTemplateAdd, constants.resource.letterTemplate) && user_type !== 'super-admin'"
                  v-b-modal.modal-role
                  variant="primary"
                  @click="letterTemplate(addLetterInput)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_LETTER_TEMPLATE') }}</span>
                </b-button> -->
                <b-button
                  v-if="$ability.can(constants.action.permissionLogin, constants.resource.user) && user_type !== 'super-admin'"
                  v-b-modal.modal-role
                  variant="primary"
                  @click="letterTemplate(addLetterInput)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_LETTER_TEMPLATE') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="tableFields"
          :items="templatesData"
        >
          <template #cell(companyname)="data">
            {{ data.item.get_company.name }}
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionLogin, constants.resource.user)"
              v-b-modal.modal-role-edit
              icon="EyeIcon"
              @click="letterTemplateDetails(data.item.id)"
            />
            <!-- <feather-icon
              v-if="$ability.can(constants.action.permissionLogin, constants.resource.user) && user_type !== 'super-admin'"
              icon="Trash2Icon"
              style="margin-left: 15px; color: #ff3737;"
              @click="confirmDeleteText(data.item.id,data.item.name)"
            /> -->
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <letter-modal
          :template-data="editData"
          :modal-loads="modalLoader"
          :reload-method="getTemplates"
          :word-file="wordFile"
          :step="finalStep"
          :variables="showVariables"
          :clicked="clicked"
        />
        <letter-details
          :template-id="templateId"
          :modal-loads="modalLoader"
          :reload-method="getTemplates"
          :template-busy="busy"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import LetterModal from './LetterModal.vue'
import LetterDetails from './LetterDetails.vue'
import axiosletter from '../../libs/axiosletter'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    LetterModal,
    LetterDetails,
  },
  data() {
    return {
      loader: false,
      templatesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addLetterInput: {
        id: 0,
        name: '',
        document_name: '',
        description: '',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      templateId: 0,
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
      wordFile: false,
      finalStep: false,
      showVariables: false,
      busy: false,
      clicked: false,
      searchRun: false,
      letter_client_id: '',
      letter_secret: '',
    }
  },
  computed: {
    tableFields() {
      let fields = []
      if (this.user_type === 'super-admin') {
        fields = [
          { key: 'id', sortable: true },
          { key: 'name', sortable: true, label: i18n.t('DEBTIA_TITLE') },
          { key: 'companyname', sortable: true, label: i18n.t('DEBTIA_COMPANY_NAME') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      } else {
        fields = [
          { key: 'id', sortable: true },
          { key: 'name', sortable: true, label: i18n.t('DEBTIA_TITLE') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      }
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getTemplates()
        }
      },
    },
    currentPage: {
      handler() {
        this.getTemplates()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getTemplates()
      },
    },
  },
  created() {
    this.getApiSettings()
    this.actionColumn()
  },
  methods: {
    async getApiSettings() {
      await axios.get('/api-token/default?module=physical-letters').then(settings => {
        if (settings.status) {
          this.letter_client_id = settings.data.data.client_id
          this.letter_secret = settings.data.data.secret
          this.getTemplates()
        }
      })
    },
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getTemplates()
      }
    },
    async getTemplates() {
      try {
        const url = 'list-all-letters'
        this.loader = true
        const headers = {
          clientId: this.letter_client_id,
          secret: this.letter_secret,
        }
        const templates = await axiosletter.get(`/letters-api/${url}?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}&sortDesc=true`, {
          headers,
        })
        this.loader = false
        if (templates.status) {
          console.log('templates', templates)
          this.templatesData = templates.data.data.data
          this.totalPages = templates.data.data.total
          this.from = templates.data.data.from
          this.to = templates.data.data.to
          this.currentPage = templates.data.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    letterTemplateDetails(id) {
      this.busy = true
      this.templateId = id
    },
    letterTemplate(item) {
      this.modalLoader = true
      this.wordFile = !this.wordFile
      this.finalStep = !this.finalStep
      this.showVariables = !this.showVariables
      this.editData = item
      this.modalLoader = false
      this.clicked = !this.clicked
    },
    async deleteTemplate(id) {
      this.loader = true
      const headers = {
        clientId: this.letter_client_id,
        secret: this.letter_secret,
      }
      const templates = await axiosletter.post('/letters-api/delete',
        { templateID: id }, {
          headers,
        })
      if (templates.status) {
        this.getTemplates()
      }
      this.loader = false
    },
    confirmDeleteText(id, name) {
      // methodId
      const question = ` '${name}' ?`
      this.$swal({
        title: i18n.t('DEBTIA_WARNING'),
        text: i18n.t('DEBTIA_DELETION_MSG') + question,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteTemplate(id)
        }
      })
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionLogin, this.constants.resource.user) && this.$ability.cannot(this.constants.action.permissionLogin, this.constants.resource.user)) {
        if (this.user_type !== 'super-admin') {
          this.tableFields.splice(2, 1)
        } else {
          this.tableFields.splice(3, 1)
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
